import type { ReactNode } from 'react';

/** The frame of the sign-in screens (the prototype's gate layout): logo, portal name, one card. */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="auth">
      <img className="logo" src="/logo.png" alt="Waste Robotics" width={240} height={47} />
      <h1 className="page">Sales Portal</h1>
      <section className="card" aria-labelledby="auth-title">
        <h2 id="auth-title" className="sec">
          {title}
        </h2>
        {children}
      </section>
    </main>
  );
}
